import React, {useCallback, useState} from 'react';
import services from '../../data/services';
import ServiceModal from './ServiceModal';

const ServicesSection = () => {
    const [active, setActive] = useState(null);
    const close = useCallback(() => setActive(null), []);

    return (
        <div id="services" className="sw-services">
            <div className="sw-container sw-services__inner">
                <div className="sw-services__head">
                    <p className="sw-eyebrow">Understand your options</p>
                    <h2 className="sw-heading sw-services__title">
                        Support for your mind.<br/>Skills for everyday life.
                    </h2>
                    <p className="sw-services__lede">
                        Start with what you need help with. If you’re unsure which service fits, our intake team
                        can help you find the right next step.
                    </p>
                </div>
                <div className="sw-services__grid">
                    {services.map((service, index) => (
                        <div key={service.slug} className="sw-services__card">
                            <span className="sw-services__card-number">{String(index + 1).padStart(2, '0')}</span>
                            <h3 className="sw-services__card-title">{service.title}</h3>
                            <p className="sw-services__card-text">{service.summary}</p>
                            <button
                                type="button"
                                className="sw-services__card-link"
                                onClick={() => setActive(service)}
                            >
                                Learn about this service
                            </button>
                        </div>
                    ))}
                </div>
            </div>
            <ServiceModal service={active} onClose={close}/>
        </div>
    );
};

export default ServicesSection;
